"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusFilter = void 0;
var mobx_react_1 = require("mobx-react");
var React = require("react");
var multiSelect_1 = require("../lib/multiSelect");
var StatusFilter = (function (_super) {
    __extends(StatusFilter, _super);
    function StatusFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChangeParent = null;
        _this.onChangeRisk = function (value, checked) { return _this.applyChange(value, checked, "risk"); };
        _this.onChangeControl = function (value, checked) { return _this.applyChange(value, checked, "control"); };
        _this.onChangeAction = function (value, checked) { return _this.applyChange(value, checked, "action"); };
        _this.onCheckAllActions = function () { return _this.onCheckAll("actions"); };
        _this.onCheckAllControls = function () { return _this.onCheckAll("controls"); };
        _this.onCheckAllRisks = function () { return _this.onCheckAll("risks"); };
        _this.onUncheckAllActions = function () { return _this.onUncheckAll("actions"); };
        _this.onUncheckAllControls = function () { return _this.onUncheckAll("controls"); };
        _this.onUncheckAllRisks = function () { return _this.onUncheckAll("risks"); };
        _this.handleChangeParent = _this.props.handleChangeParent;
        _this.state = {
            action_status_to_display: [],
            control_status_to_display: [],
            risk_status_to_display: [],
            all_action_status_values: [],
            all_control_status_values: [],
            all_risk_status_values: [],
        };
        return _this;
    }
    StatusFilter.prototype.hasChoices = function () {
        return (this.state.all_action_status_values.length > 0 &&
            this.state.all_control_status_values.length > 0 &&
            this.state.all_risk_status_values.length > 0);
    };
    ;
    StatusFilter.prototype.componentWillReceiveProps = function (props) {
        if (!this.hasChoices()) {
            var all_action_status_values = props.action_status_choices.map(function (c) { return c.value; });
            var all_control_status_values = props.control_status_choices.map(function (c) { return c.value; });
            var all_risk_status_values = props.risk_status_choices.map(function (c) { return c.value; });
            this.setState({
                action_status_to_display: all_action_status_values,
                control_status_to_display: all_control_status_values,
                risk_status_to_display: all_risk_status_values,
                all_action_status_values: all_action_status_values,
                all_control_status_values: all_control_status_values,
                all_risk_status_values: all_risk_status_values,
            });
        }
    };
    StatusFilter.prototype.updateStatusChoices = function (value, checked, list) {
        var listCopy = list.slice();
        if (checked && !this.isSelected(value, list)) {
            listCopy.push(value);
        }
        else if (!checked && this.isSelected(value, list)) {
            var position = listCopy.indexOf(value);
            listCopy.splice(position, 1);
        }
        return listCopy;
    };
    StatusFilter.prototype.applyChange = function (value, checked, type) {
        var risk_status_to_display = this.state.risk_status_to_display;
        var control_status_to_display = this.state.control_status_to_display;
        var action_status_to_display = this.state.action_status_to_display;
        if (type == "risk")
            risk_status_to_display = this.updateStatusChoices(value, checked, risk_status_to_display);
        else if (type == "control")
            control_status_to_display = this.updateStatusChoices(value, checked, control_status_to_display);
        else if (type == "action")
            action_status_to_display = this.updateStatusChoices(value, checked, action_status_to_display);
        var newState = {
            risk_status_to_display: risk_status_to_display,
            control_status_to_display: control_status_to_display,
            action_status_to_display: action_status_to_display,
        };
        this.setState(newState);
        this.handleChangeParent(this.state);
    };
    StatusFilter.prototype.onCheckAll = function (type) {
        var risk_status_to_display = this.state.risk_status_to_display;
        var control_status_to_display = this.state.control_status_to_display;
        var action_status_to_display = this.state.action_status_to_display;
        if (type == "risks") {
            risk_status_to_display = ["10", "20", "30", "40"];
        }
        else if (type == "controls") {
            control_status_to_display = ["10", "20", "30", "40", "50"];
        }
        else if (type == "actions") {
            action_status_to_display = ["10", "20", "30", "40", "50"];
        }
        var newState = {
            risk_status_to_display: risk_status_to_display,
            control_status_to_display: control_status_to_display,
            action_status_to_display: action_status_to_display,
        };
        this.setState(newState);
        this.handleChangeParent(this.state);
    };
    StatusFilter.prototype.onUncheckAll = function (type) {
        var risk_status_to_display = this.state.risk_status_to_display;
        var control_status_to_display = this.state.control_status_to_display;
        var action_status_to_display = this.state.action_status_to_display;
        if (type == "risks")
            risk_status_to_display = [];
        else if (type == "controls")
            control_status_to_display = [];
        else if (type == "actions")
            action_status_to_display = [];
        var newState = {
            risk_status_to_display: risk_status_to_display,
            control_status_to_display: control_status_to_display,
            action_status_to_display: action_status_to_display,
        };
        this.setState(newState);
        this.handleChangeParent(this.state);
    };
    StatusFilter.prototype.isSelected = function (status, to_display_list) {
        return to_display_list.indexOf(status) != -1;
    };
    StatusFilter.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("form", null,
                React.createElement("h3", null, get_term("Risk Filter")),
                React.createElement(multiSelect_1.Multiselect, { choices: this.props.risk_status_choices, name: "risk_status_filter", value: this.state.risk_status_to_display, onSingleChange: this.onChangeRisk, onCheckAll: this.onCheckAllRisks, onUncheckAll: this.onUncheckAllRisks, selectedText: gettext('status(es) selected'), noneSelectedText: gettext("Select statuses"), classes: "MultiSelect__Button gm--fullwidth" }),
                React.createElement("h3", null, get_term("Control Filter")),
                React.createElement(multiSelect_1.Multiselect, { choices: this.props.control_status_choices, name: "control_status_filter", value: this.state.control_status_to_display, onSingleChange: this.onChangeControl, onCheckAll: this.onCheckAllControls, onUncheckAll: this.onUncheckAllControls, selectedText: gettext('status(es) selected'), noneSelectedText: gettext("Select statuses"), classes: "MultiSelect__Button gm--fullwidth" }),
                React.createElement("h3", null, gettext("Action Filter")),
                React.createElement(multiSelect_1.Multiselect, { choices: this.props.action_status_choices, name: "action_status_filter", value: this.state.action_status_to_display, onSingleChange: this.onChangeAction, onCheckAll: this.onCheckAllActions, onUncheckAll: this.onUncheckAllActions, selectedText: gettext('status(es) selected'), noneSelectedText: gettext("Select statuses"), classes: "MultiSelect__Button gm--fullwidth" }))));
    };
    StatusFilter = __decorate([
        mobx_react_1.observer
    ], StatusFilter);
    return StatusFilter;
}(React.Component));
exports.StatusFilter = StatusFilter;
